module.exports = __webpack_public_path__ + "media/usp-diets-17c56889.svg";